
import Tabs from '~/components/generic/Tabs.vue';
import Tab from '~/components/generic/Tab.vue';
import TypeOfClientsTab from '~/components/page-components/aboutpage/TypeOfClientsTab.vue';
import TypeOfProductsTab from '~/components/page-components/aboutpage/TypeOfProductsTab.vue';

export default {
  components: { Tabs, Tab, TypeOfClientsTab, TypeOfProductsTab }
};
